import styled from "styled-components";

export const VideoContainer = styled.div<{grid: boolean}>`
  height: ${(props) => props.grid ? '785px' : '900px'};
  width: 1200px;
  border: 25px solid gray;
  border-top-width: 15px;
  background-color: gray;
`;

export const Label = styled.div`
  width: 1250px;
  height: 175px;
  font-size: 50px;
  background-color: gray;
  color: white;

  p { 
    font-size: 30px;
    color: white;
    margin: 0px 0px 0px 0px;
  }
`;
